import { render } from "./OidoValueList.vue?vue&type=template&id=735b4768&scoped=true"
import script from "./OidoValueList.vue?vue&type=script&lang=js"
export * from "./OidoValueList.vue?vue&type=script&lang=js"

import "./OidoValueList.vue?vue&type=style&index=0&id=735b4768&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735b4768"]])

export default __exports__